// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"PaymentMethod_dropdown__1bCyx"};